import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyAccountComponent } from './my-account.component';
import { UserInfoComponent } from './components/user-info/user-info.component';
import { QuotaInfoComponent } from './components/quota-info/quota-info.component';
import { EditUserComponent } from './components/edit-user/edit-user.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { EditUserQuotaComponent } from './components/edit-user-quota/edit-user-quota.component';
import { TranslateModule } from 'ng2-translate';
import { MaterialModule } from '@angular/material';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    SharedModule,
    MaterialModule
  ],
  declarations: [
    MyAccountComponent,
    UserInfoComponent,
    QuotaInfoComponent,
    EditUserComponent,
    EditUserQuotaComponent
  ],
  exports: [MyAccountComponent],
  entryComponents: [
    EditUserComponent,
    EditUserQuotaComponent
  ]
})
export class MyAccountModule { }



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/myaccount/my-account.module.ts